import { useSelector, useDispatch } from 'react-redux';
import {
  selectPanelTypes,
  selectOutputTypes,
  selectOutputCategories,
  addPanelType,
  updatePanelType,
  removePanelType,
  addOutputType,
  updateOutputType,
  removeOutputType,
  updatePanelOutputs,
  updateAllowedChildPanels,
  resetToDefaults,
} from '../../../redux/panelConfigSlice';
import { getPanelMenuItems } from '../../../utils/panelMenuBuilder';

/**
 * usePanelConfig - Panel config verilerine erişim ve dispatch wrapper'ları
 */
export function usePanelConfig() {
  const dispatch = useDispatch();
  const panelTypes = useSelector(selectPanelTypes);
  const outputTypes = useSelector(selectOutputTypes);
  const outputCategories = useSelector(selectOutputCategories);

  const getMenuItems = (panelTypeId) => {
    return getPanelMenuItems(panelTypeId, panelTypes, outputTypes, outputCategories);
  };

  return {
    panelTypes,
    outputTypes,
    outputCategories,
    getMenuItems,
    addPanelType: (pt) => dispatch(addPanelType(pt)),
    updatePanelType: (pt) => dispatch(updatePanelType(pt)),
    removePanelType: (id) => dispatch(removePanelType(id)),
    addOutputType: (ot) => dispatch(addOutputType(ot)),
    updateOutputType: (ot) => dispatch(updateOutputType(ot)),
    removeOutputType: (id) => dispatch(removeOutputType(id)),
    updatePanelOutputs: (payload) => dispatch(updatePanelOutputs(payload)),
    updateAllowedChildPanels: (payload) => dispatch(updateAllowedChildPanels(payload)),
    resetToDefaults: () => dispatch(resetToDefaults()),
  };
}
